import { z } from 'zod';
import { ReportReasonName } from './items.js';
/** Mini App (learner) API contracts (M6). Auth: `Authorization: Bearer <session token>`. */
export const MiniAppSessionRequest = z
    .object({
    productKey: z.string().regex(/^[a-z0-9][a-z0-9_-]{0,63}$/),
    initData: z.string().min(1).max(8192),
})
    .strict();
export const MiniAppSessionDto = z.object({
    token: z.string(),
    expiresAt: z.string(),
    productId: z.string(),
    firstName: z.string().nullable(),
    examKey: z.string().nullable(),
});
export const SaveAnswersRequest = z
    .object({
    answers: z
        .array(z
        .object({
        itemId: z.uuid(),
        choice: z.number().int().min(0).max(3).nullable(),
        marked: z.boolean().optional(),
        timeMs: z
            .number()
            .int()
            .min(0)
            .max(4 * 3_600_000)
            .optional(),
        seq: z.number().int().min(1),
    })
        .strict())
        .min(1)
        .max(300),
})
    .strict();
/** "Report a problem" with a question in the player (ADR 0044); same reasons as the bot. */
export const MiniAppReportRequest = z
    .object({
    itemId: z.uuid(),
    reason: ReportReasonName,
    note: z.string().trim().max(500).optional(),
})
    .strict();
export const MiniAppMockQuery = z
    .object({
    exam: z
        .string()
        .regex(/^[a-z][a-z0-9_]*$/)
        .max(64)
        .optional(),
})
    .strict();
/** Responses are documented loosely; the Mini App shares the TypeScript types. */
export const LooseDto = z.looseObject({});
//# sourceMappingURL=miniapp.js.map